import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatabaseApiServiceService } from '../../../database-api-service.service';
import Swal from 'sweetalert2'
import { Constants } from "src/app/constants";
import { Router } from '@angular/router';

@Component({
  selector: "app-card-settings",
  templateUrl: "./card-settings.component.html",
})
export class CardSettingsComponent implements OnInit {

  myUserForm: FormGroup;

  username: string;

  lockForm: Boolean;

  constructor(private fb: FormBuilder, private databaseService: DatabaseApiServiceService, private router: Router) {}

  ngOnInit(): void {
    this.lockForm = false;
    this.username = localStorage.getItem(Constants.USER)
    this.myUserForm = this.fb.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  createUser(){
    alert(this.myUserForm.value.firstName);
    console.log(this.myUserForm);
  }
  changePassword(){

    this.lockForm = true;

    if(this.myUserForm.value.password != this.myUserForm.value.confirmPassword){
      Swal.fire({
        title: 'Error!',
        text: "Passwords do not match. Please ensure both passwords are the same.",
        icon: 'error',
        confirmButtonText: 'Okay'
      })
      this.lockForm = false;
      return;
    }
    if(this.myUserForm.value.username === ''){
      Swal.fire({
        title: 'Error!',
        text: 'Please fill out username field to change password.',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
      this.lockForm = false;
      return;
    }

    if(this.myUserForm.value.password.includes("'")){
      Swal.fire({
        title: 'Invalid Password',
        text: "Please ensure your password does not include any apostrophes (')",
        icon: 'error',
        confirmButtonText: 'Cool'
      })
      this.lockForm = false;
      return;
    }

    this.databaseService.changePassword(this.username, this.myUserForm.value.password).subscribe((result) => {
      console.log(result);
      if(result.status == Constants.SUCCESS_CODE){
        this.lockForm = false;
        Swal.fire({
          title: 'Success',
          text: Constants.CHANGE_PASSWORD_SUCCESS_MESSAGE,
          icon: 'success',
          confirmButtonText: 'Cools'
        })
        this.router.navigate(['admin/tables']);
      }
      else{
        this.lockForm = false;
        Swal.fire({
          title: 'Error!',
          text: result.message,
          icon: 'error',
          confirmButtonText: 'Okay'
        })
        return;
      }
    })
  }

  public goToDocumentsPage(): void{
    this.router.navigate(['admin/tables'])
  }
}
